module.exports = __webpack_public_path__ + "img/keyboard-replacement.e8e27226.png";